import { DependencyList, useEffect, useRef } from 'react';
import { reportCatchError } from '@/utils/reportCatchError';
import { reportInp } from '@/common/perf/inp';

/***
 * demo:
 * function() {
 *    const [state, setState] = useState();
 *    const stateToNextTick = useNextTick([state]);
 *    xhr.then((data) => {
 *        stateToNextTick.nextTick(() => {
 *            // nextTick event
 *        });
 *        setState(data);
 *    })
 * }
 */
export function useNextTick(deps: DependencyList) {
    const callbackRef = useRef<() => void>();
    const isRecorded = useRef(false);

    useEffect(() => {
        if (callbackRef.current) {
            const func = callbackRef.current;
            callbackRef.current = null;
            Promise.resolve()
                .then(() => {
                    if (!isRecorded.current) {
                        isRecorded.current = true;
                        func();
                        reportInp();
                    }
                })
                .catch(e => {
                    reportCatchError(e, {
                        position: 'useNextTick',
                    });
                });
        }
    }, deps);

    return {
        nextTick(callback) {
            callbackRef.current = callback;
        },
    };
}
